/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseSectionDivision } from './CourseSectionDivision';
import { ExtendedCourseSection } from './ExtendedCourseSection';
const CreateDivisionResultParser = 
/* #__PURE__ */ parsers.object([
    ['section', ExtendedCourseSection],
    ['division', CourseSectionDivision],
]);
export class CreateDivisionResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateDivisionResultParser.decode(input).map(res => new CreateDivisionResult(res));
    }
    static unsafeDecode(input) {
        return CreateDivisionResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateDivisionResultParser.encode(data);
    }
    static schema() {
        return CreateDivisionResultParser.schema();
    }
}
